import * as THREE from 'three'
import React, { useRef,useEffect, useState } from 'react'
import { useSprings, a } from '@react-spring/three'
import {  useThree, useFrame } from '@react-three/fiber'


import Book from '../Book'
import CarouselPlayButton from './CarouselPlayButton'
import {
    useSceneStore,
  } from '../store'

  import useStore from '../store/scroll'

//import './styles.css'
const rfs = THREE.MathUtils.randFloatSpread
const number = 3
//const colors = ['#A2CCB6', '#FCEEB5', '#EE786E', '#e0feff', 'lightpink', 'lightblue']

const winHeight = window.innerHeight/2;
const halfHeight = winHeight/4;

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const random = (i, width) => {
  const mobile = window.innerWidth < 700;
  const r = Math.random()
  const range = 30;
  
  // Use more reasonable positioning values
  const rightEdge = mobile ? 15 : 25; // Smaller values for visibility
  const numberOfBooks = 3;
  const ratio = window.innerHeight/window.innerWidth;
  
  const vspread = (ratio > 1) ? 20 : 15;
  const hspread = 0.8;

  return {
    position: [
      // Right side positioning with reasonable values
      rightEdge - (i * 8), // Simple spacing
      (i === (numberOfBooks-1)) ? -10 : -15 + getRandomInt(-vspread, vspread),
      i * 15 - 10 // Simple z spacing
    ],
    scale: [1, 1, 1],
    opacity: 1,
    rotation: [0, THREE.Math.degToRad(getRandomInt(-30, 30) ), THREE.Math.degToRad(getRandomInt(-20, 20) )]
  }
}

const data = new Array(number).fill().map((i) => {
  return {
   // color: colors[i],
    args: [30, 40, 2]
  }
})

function ContentOther({ movement, cycleBooks, frontIndex, playActive }) {
  const frontRef = useRef()

  const imgArr =[
    'quietship-cover-wrap.jpg',
    'strongest-thing-cover-wrap-award.jpg',
    'after-cover-wrap-kirkus-filled-darkblue.jpg',
  ]

  return (
    <>
      {data.map((d, index) => {
        const isFront = index === frontIndex
        return (
          <a.group key={index} {...movement[index]}>
            <group
              ref={isFront ? frontRef : undefined}
              onClick={playActive ? cycleBooks : undefined}
            >
              <Book rotation={[Math.PI / 2, 0, 0]} url={"assets/images/"+imgArr[index]}/>
            </group>
          </a.group>
        )
      })}
      <CarouselPlayButton
        bookRef={frontRef}
        side="right"
        id="carousel-other"
        active={playActive}
        onAdvance={cycleBooks}
      />
    </>
  )
}


export default function BookCarouselOther({ ...props}) {
  //const [bookIndex, setBookIndex] = useState(3)
  //const [triggerState, setTriggerState] = useState(trigger);
  const { setBookOtherIndex, setBookOtherState} = useSceneStore(state => state.actions)
  const { bookOtherState, bookOtherIndex, mode } = useSceneStore(state => state)

  const sectionActive = useStore(state => state.sectionActive)

  const { viewport } = useThree()
  const { width, height } = useThree((state) => state.viewport)

  const rightEdge = (width*.9) / 2; 

  // Use more reasonable positioning values
  //const rightEdge = window.innerWidth < 700 ? 15 : 25;
  const numberOfBooks = 3;

  const [springs, set] = useSprings(number, (i) => ({
    from: {
      position: [i,-4 *viewport.height,-10],
      // color: colors[Math.round(Math.random() * (colors.length - 1))],
    //  scale: [1.5, 1.5, 1.5],
      opacity: 1,
      rotation: [THREE.Math.degToRad(Math.round(Math.random()) * -80), THREE.Math.degToRad(Math.round(Math.random()) * 30), THREE.Math.degToRad(Math.round(Math.random()) * 45)]
    },
    to: {
      // Stay far off-screen until section 5 — must not appear on the intro
      position: [80, -4 * viewport.height, 800],
      opacity: 1,
      rotation: [THREE.Math.degToRad(Math.round(Math.random()) * 30), THREE.Math.degToRad(Math.round(Math.random()) * 10), THREE.Math.degToRad(Math.round(Math.random()-.3) * 85)]
    },
    config: { mass: 100, tension: 10, friction: 20 },
  }))
/*
  const [springs, set] = useSprings(number, (i) => ({
    from: {
      position: [(i*20) - Math.random() * 60, -sectionActive * viewport.height, i * 80],
      // color: colors[Math.round(Math.random() * (colors.length - 1))],
      scale: [1.5, 1.5, 1.5],
      opacity: 1,
      rotation: [THREE.Math.degToRad(Math.round(Math.random()) * -80), THREE.Math.degToRad(Math.round(Math.random()) * 30), THREE.Math.degToRad(Math.round(Math.random()) * 45)]
    },
    to: {
      position: [(i*15) - Math.random() * 50, -sectionActive * viewport.height , i * 50],
      // color: colors[Math.round(Math.random() * (colors.length - 1))],
      scale: [1, 1, 1],
      opacity: 1,
      rotation: [THREE.Math.degToRad(Math.round(Math.random()) * 30), THREE.Math.degToRad(Math.round(Math.random()) * 10), THREE.Math.degToRad(Math.round(Math.random()-.3) * 85)]
    },
    config: { mass: 100, tension: 10, friction: 20 },
    onStart: () => {

     // introCallback();
      //  console.log('did it')
    }
  }))
*/
  const [count, setCount] = useState(0);
  // 👇 look here
  const prevCount = usePrevious(count)

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  useEffect(() => {

  }, []);

  useEffect(() => {
    // Only step/stack while in the other-books section
    if (sectionActive !== 5) return
    stepBookCarousel(bookOtherIndex)
    setCount(bookOtherIndex)
  }, [bookOtherIndex, sectionActive])

  
/*
  useEffect(() => {
    //introCallback();
     // setTriggerState(trigger)
    
      if (bookOtherState === 'float'){
        relaunch();
      }else if (bookOtherState === 'stack'){
        assemble();
      }else if (bookOtherState === 'lineup'){
        alignAll();
      }else if (bookOtherState === 'scatter'){
        scatterAll();
      }
   


    
  }, [bookOtherState])
  */

  useEffect(() => {
    if (sectionActive === 5) {
      // Full stack like BookCarousel — idx === number keeps all books (i >= number is empty)
      setBookOtherIndex(number)
      stepBookCarousel(number)
      setCount(number)
    } else {
      // Keep off the intro and every non-carousel section
      hideOffscreen()
    }
  }, [sectionActive]);

  function hideOffscreen() {
    set((i) => ({
      position: [80 + i * 10, -4 * viewport.height, 800],
      opacity: 1,
      scale: [1, 1, 1],
      rotation: [0, THREE.Math.degToRad(-30), 0],
      config: { mass: 1, tension: 300, friction: 40 },
    }))
  }

  function relaunch() {
    console.log('relaunch')

    set((i) => ({ ...random(i, width), config: { mass: 20, tension: 10, friction: 20 }, delay: i * 40 }))
    
  }
  function assemble() {
    console.log('OTHER assemble')
   // setBookOtherIndex(5)
    setBookOtherIndex(1)
    const mobile = window.innerWidth < 700;
    const xoffset = (mobile)? 15 : 40;
    const zoffset = (mobile)? 60 : 150;
    set((i) => ({
      ...{
       // position: [i * 6- xoffset, 0, i * 17 + zoffset],
        position: [
          // Right side positioning with reasonable values
          (mobile) ? rightEdge - (i*3- 10) : rightEdge - (i*20 + xoffset), 
          -sectionActive * viewport.height - 15,  
           zoffset  
        // 20// (mobile) ? i * 10 + 80   : i * 17 + zoffset  
        ],
        // color: colors[Math.round(Math.random() * (colors.length - 1))],
        opacity: 1,
        scale: [1, 1, 1],
        rotation: [0, THREE.Math.degToRad(45), THREE.Math.degToRad(0)]
      },
      config: { mass: 20, tension: 200, friction: 97 },
      delay: i * 40
    }))
  }

  function alignAll() {
    console.log('align')
    set((i) => ({
      ...{
        // Right side positioning with reasonable values
        position: [rightEdge - (i * 25), 0, -120],
        opacity: 1,
        // color: colors[Math.round(Math.random() * (colors.length - 1))],
        scale: [1, 1, 1],
        rotation: [0, THREE.Math.degToRad(0), THREE.Math.degToRad(0)]
      },
      config: { mass: 20, tension: 200, friction: 97 },
      delay: i * 40
    }))
  }

  function scatterAll() {
    console.log('scatter')
   /// setBookOtherState('scatter')
    set((i) => ({
      ...{
      //  position: [i * 40 - rfs(500), rfs(500), -200 - rfs(1000)],
        // Right side positioning with reasonable values
        position: [rightEdge - (i * 40 + rfs(200)),  -sectionActive * viewport.height + rfs(100) -200, -200 - rfs(100)],
        opacity: 1,
        // color: colors[Math.round(Math.random() * (colors.length - 1))],
        scale: [1, 1, 1],
        rotation: [0, THREE.Math.degToRad(0), THREE.Math.degToRad(0)]
      },
      config: { mass: 20, tension: 200, friction: 97, precision: 0.0001 },
      delay: i * 40
    }))
  }

  function cycleBooks(){
    // Only advance while the other-books carousel is stacked in its section
    if (sectionActive !== 5) return
    if (count > 1) {
      setBookOtherIndex(count - 1)
    } else {
      setBookOtherIndex(number)
    }
  }



  function stepBookCarousel(idx, reverse = 0) {

    //console.log('Step Other Carousel', idx)

    const mobile = window.innerWidth < 700;
   // const xoffset = (mobile)? 15 : 40;
   // const zoffset = (mobile)? 80 : 140;

    const xoffset = (mobile)? 15 : 42;
    const zoffset = (mobile)? 60 : 120;
    const numberOfBooks = 3;
    const rightEdge = (width*.9) / 10; 

  //  console.log('idx----', idx)

    set((i) =>
      i >= idx
        ? {
            //  if (i===idx) {
            ...{
             // position: reverse === 0 ? [i * 10, 0, i * 20 + 200] : [i * 10 - 60, 0, i * 20 + 80],
             // position: [40, 0, 500],
              // Right side positioning with reasonable values
              position: [
                rightEdge - 20, 
               
              //  -sectionActive * viewport.height, 
                (mobile) ? -sectionActive * viewport.height + viewport.height/2   : -sectionActive * viewport.height ,  
                500],
              // color: colors[Math.round(Math.random() * (colors.length - 1))],
              scale: [1, 1, 1],
            //  opacity: i === idx ? reverse : 1,
              rotation: [0, THREE.Math.degToRad(-30), THREE.Math.degToRad(0)]
            },
            config: { mass: 1, tension: 300, friction: 97 }
            // delay: i * 40

            // }
          }
        : {
          //  if (i===idx) {
           
          ...{
           // position: reverse === 0 ? [i * 10, 0, i * 20 + 200] : [i * 10 - 60, 0, i * 20 + 80],
      //      position: [i * 8 - xoffset, 0, i * 15 + zoffset],

       //     position: [i * 6- xoffset, 0, i * 17 + zoffset],
    //   position: [i*6- xoffset + 36 - (idx*6) - (6-idx) , 0,  i * 17 + zoffset + 72 - (idx*12)  ],
  //  position: [i*3- 10 + 18 - (idx*3) - (6-idx) , 0,  i * 8.5 + zoffset + 36 - (idx*6)  ],
   // position: [i*3- 10  , 0,  i * 10 + 80  ],
    // Right side positioning with reasonable values
    position: [
      // X position - simplified mirror logic
   //   rightEdge + (width / numberOfBooks*0.6) * i,
   (mobile) ? (i*4) -rightEdge : rightEdge,
  // (mobile) ? ( i*4 - 4 ) : rightEdge - (10 - i*2 ), 
   //   (mobile) ? 
     //   rightEdge - (i*3- 10 + 18 - (idx*3) - (6-idx)) : rightEdge - (10 - i*2 ), 
      (mobile) ? -sectionActive * viewport.height + viewport.height/2 - 30  : -sectionActive * viewport.height - 10,  
      (mobile) ? i * 10 + 80 + 72 - (idx*12)  : i * 20+ zoffset + 72 - (idx*12) 
    ],
        //    position: [i * 6 - xoffset + (24/bookIndex )-4 , 0, i * 17 + zoffset + (6*10/(bookIndex+1)) ],
            // color: colors[Math.round(Math.random() * (colors.length - 1))],
            scale: [1, 1, 1],
          //  opacity: i === idx ? reverse : 1,
            rotation: [0, THREE.Math.degToRad(-30), THREE.Math.degToRad(0)]
          },
          config: { mass: 20, tension: 200, friction: 100, precision: 0.0001 }
          // delay: i * 40

          // }
        }
    )
  }

  return (
    <>
         {/*   <axesHelper scale={80} /> */}

            <ContentOther
              movement={springs} 
              cycleBooks={cycleBooks}
              // stepBookCarousel dismisses i >= idx, so front remaining is idx - 1
              // (when idx === number, all books stay and front is the last)
              frontIndex={
                bookOtherIndex >= number
                  ? number - 1
                  : Math.max(0, bookOtherIndex - 1)
              }
              playActive={mode !== 'grid' && sectionActive === 5}
            // introCallback={introCallback}
              />
  
    </>
  )
}